<template>
  <div>
    <div ref="chart" class="worksTime" v-show="info"></div>
    <div v-show="!info" class="chart">
      <none-data :height="3.5" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dayNum: Number,
    onlySales: Boolean,
  },
  data() {
    return {
      info: true,
    };
  },
  mounted() {
    this.getworksTime();
  },
  computed: {},
  watch: {
    dayNum: {
      handler() {
        this.getworksTime();
      },
    },
  },
  methods: {
    getworksTime() {
      this.$get({
        road: "opusPublish",
        data: { anchorId: this.$route.params.id, road: "gifshow" },
        params: { mode: "daily" },
        version: "v2",
      })
        .then((res) => {
          this.info = res.length;
          const num = res.reduce((val, item) => val + item.opus, 0);
          const arr1 = res.map((item) => {
            return item.opus;
          });
          const arr2 = res.map((item) => {
            const obj = {
              time: item.hours.toString().padStart(2, 0) + ":00",
              Times: `${item.hours.toString().padStart(2, 0)}:00-${(
                item.hours + 1
              )
                .toString()
                .padStart(2, 0)}:00`,
              works: ((item.opus / num) * 100).toFixed(1),
            };
            return JSON.stringify(obj);
          });
          this.drawChart({ y: arr1, x: arr2 });
        })
        .finally(() => {
          this.$toast.clear();
        });
    },
    // 字体适配
    FontChart(res) {
      //获取到屏幕的宽度
      var clientWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      if (!clientWidth) return; //报错拦截：
      let fontSize = 10 * (clientWidth / 1920);
      return res * fontSize;
    },
    drawChart(info) {
      echarts.init(this.$refs.chart).setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          formatter: (data) => {
            const item = JSON.parse(data[0].name)
            return `<div style="font-family: number-bold;">
            <div style="display:flex;align-items: center;">
              <span style="font-size:14px;color:#252E39;margin-right:6px">发布时间占比</span>
              <span style="font-size:14px;color:#252E39;">${item.Times}</span>
            </div>
            <div style="display:flex;align-items: center;">
              <div style="width: 8px;height: 8px;background: linear-gradient(180deg, rgba(40, 119, 255, 0.85) 0%, rgba(40, 119, 255, 0.51) 100%);margin-right: 5px;"></div>
              <span style="font-size:12px;color:#696D75;margin-right:16px">发布时间占比</span><span style="font-size:14px;color:#4a4a4a;">${item.works}%</span>
            </div>
                  </div>`;
          },
        },
        xAxis: {
          type: "category",
          data: info.x,
          axisLabel: {
            formatter: (val) => JSON.parse(val).time,
          },
        },
        yAxis: {
          type: "value",
          show: false,
        },
        series: [
          {
            data: info.y,
            type: "bar",
            showSymbol: false,
            showBackground: true,
            backgroundStyle: {
            borderRadius:[4,4,0,0],
            color: '#F6F7F7'},
            itemStyle: {
              normal: {
                borderRadius:[4,4,0,0],
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#2A89F4' },
                  { offset: 1, color: '#BBDBFF' }
                ])
              }
               },
          },
        ],
        grid: {
          left: this.FontChart(11),
          top: this.FontChart(5),
          bottom: this.FontChart(14),
          right: this.FontChart(5),
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.worksTime {
  margin-top: 0.24rem;
  width: 7rem;
  height: 3.7rem;
}
.chart_box {
  width: 100px;
  height: 100px;
  background-color: #000;
}
</style>
